import React, { useEffect, useState } from 'react';
import useLogger from 'hooks/useLogger';
import dayjs from 'dayjs';
import { checkIfPreOrderSKU } from '../../utility/utils';
import { SkuDetails } from '../FulfillmentOptions/types';

type Props = {
  sku: SkuDetails | null;
};

const PreOrderMessaging = ({ sku }: Props) => {
  const [preSaleEndDate, setPreSaleEndDate] = useState<string | null>(null);
  const { warn } = useLogger();

  useEffect(() => {
    if (sku) {
      try {
        const preSaleSku = checkIfPreOrderSKU(sku, warn);
        if (preSaleSku?.value) {
          setPreSaleEndDate(dayjs(preSaleSku.value, 'MM-DD-YYY').format('ddd, MMM D'));
        }
      } catch (e) {
        warn('PreOrderMessaging - ', e);
      }
    }
  }, [sku]);

  if (!preSaleEndDate) return null;

  return (
    <p className="quickview-pre-order-messaging">
      Pre-Order Product. Ships after {preSaleEndDate}.
    </p>
  );
};

export default PreOrderMessaging;
